export interface Conversacion {
  id: string
  organizacion_id: string
  tipo: 'direct' | 'group' | 'channel'
  nombre: string | null
  created_by: string | null
  created_at: string
  updated_at: string
}

export interface ConversacionConPreview extends Conversacion {
  ultimo_mensaje: string | null
  ultimo_sender: string | null
  ultimo_mensaje_at: string | null
  member_count: number
  otro_usuario: string
  no_leidos: number
  muted: boolean
}

export interface ChatMiembro {
  id: string
  conversacion_id: string
  user_email: string
  last_read_message_id: string | null
  role: 'admin' | 'member'
  muted: boolean
  joined_at: string
}

export interface Mensaje {
  id: string
  conversacion_id: string
  sender_email: string
  content: string
  deleted_at: string | null
  created_at: string
  /** @deprecated Legacy: contenía signed URLs con TTL 1h. Usar attachment_path. */
  attachment_url: string | null
  /** Path relativo dentro del bucket chat-attachments. Signed URL se genera on-demand (useAttachmentUrl). */
  attachment_path: string | null
  attachment_type: string | null
  attachment_name: string | null
  attachment_size: number | null
}

export interface MensajeInsert {
  conversacion_id: string
  sender_email: string
  content: string
  /** Path en bucket chat-attachments. NO guardar URLs firmadas aquí. */
  attachment_path?: string
  attachment_type?: string
  attachment_name?: string
  attachment_size?: number
}

export const CHAT_FILE_MAX_SIZE = 10 * 1024 * 1024 // 10MB
export const CHAT_FILE_ALLOWED_TYPES = [
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'application/pdf',
  'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
]

export interface CrearGrupoInput {
  nombre: string
  miembros: string[]
}

export interface TypingEvent {
  conversacion_id: string
  user_email: string
  is_typing: boolean
}

export type ConnectionStatus = 'connected' | 'reconnecting' | 'disconnected'
